import { render, staticRenderFns } from "./FilterProductBrands.vue?vue&type=template&id=5ef15200&"
import script from "./FilterProductBrands.vue?vue&type=script&lang=js&"
export * from "./FilterProductBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports